<template>
	<sf-data-table
		class="stationTable"
		:excel="isButton_(scrId, 'EX')"
		:customExcel="excelFunc"
		:columns="columns"
		:rows="rows"
		index
		paging
		@changedPage="onChangePage"
		:currentPage="stations.currentPage"
		:pageUnit="stations.pageUnit"
		:pageArray="screen.pageArray"
		:totalSize="stations.totalSize"
	>
		<template v-slot:customRows="slotProps">
			<tr v-for="(flag, index) in flags" :key="index">
				<template v-if="slotProps.column.property === flag.value.toLowerCase()"
					><span :class="{ 'flag-status': slotProps.row[flag.value.toLowerCase()] === 'Y' }">
						{{ slotProps.row[flag.value.toLowerCase()] }}</span
					></template
				>
			</tr>
		</template>
	</sf-data-table>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/RegisterReportingPoint/store/helpers';
import { utils } from '@sfaas/util';
import { BASE_URL } from '@/constants';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			screen: {}
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed,

		columns() {
			const flagsColumns = this.flags.map(flag => {
				return { prop: flag.value.toLowerCase(), label: flag.label, width: '150px', custom: true };
			});

			return [
				{
					label: this.getMessage_('SWCC000529'),
					prop: 'stnCd',
					width: '150px',
					clickEvent: this.onClick,
					highlight: true,
					fixed: true
				},
				{
					label: this.getMessage_('SWCC000589'),
					prop: 'stnName',
					width: '200px',
					fixed: true
				},
				{
					label: this.getMessage_('SWCC000016'),
					prop: 'shopCd',
					width: '200px'
				},
				{
					label: this.getMessage_('SWCC000591'),
					prop: 'lineCd',
					width: '150px'
				},
				{
					label: this.getMessage_('SWCC000692'),
					prop: 'cid',
					width: '150px'
				},
				{
					label: this.getMessage_('SWCC000693'),
					prop: 'hid',
					width: '150px'
				},
				{
					label: this.getMessage_('SWCC000811'),
					prop: 'aid',
					width: '150px'
				},
				{
					label: this.getMessage_('SWCC000812'),
					prop: 'tid',
					width: '150px'
				},
				{
					label: this.getMessage_('SWCC000597'),
					prop: 'fairStock',
					width: '150px'
				},
				{
					label: this.getMessage_('SWCC000598'),
					prop: 'maxStock',
					width: '150px'
				},
				{
					label: this.getMessage_('SWCC000599'),
					prop: 'minStock',
					width: '150px'
				},
				...flagsColumns,
				{
					label: this.getMessage_('SWCC000005'), // 등록자
					prop: 'regId',
					minWidth: '150px',
					sortable: false
				},
				{
					label: this.getMessage_('SWCC000004'), // 등록일
					prop: 'dRegDt',
					minWidth: '180px',
					sortable: false
				}
			];
		},
		rows() {
			return this.stations.data.map(station => ({
				...station,
				shopCd: this.shopCdConverter(station.shopCd),
				lineCd: this.lineCdConverter(station.lineCd)
			}));
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		...utils,

		excelFunc() {
			const url = `${BASE_URL}/station/v1/plants/${this.user.plantCd}/stations`;
			const params = { url, columns: this.columns };
			this.$sf_toggleLoading(true);
			this.xlsxDown(params)
				.then(header => {
					this.$sf_showMessage({
						...this.$sf_setMessageOption(header),
						message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
					});
				})
				.catch(error => {
					this.$sf_showMessage({ title: 'Error', icon: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		//페이징 정보 변경 이벤트
		onChangePage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || !prePageUnit) {
				return; //초기 중복 조회 방지.
			}
			this.search({ currentPage: currentPageVal, pageUnit: pageUnitVal });
		},

		search({ currentPage, pageUnit }) {
			this.$sf_toggleLoading(true);
			this.select_({
				...this.searchParams,
				currentPage,
				pageUnit
			})
				.then(header => {
					this.$sf_toast({
						...this.$sf_setToastOption(header),
						message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
					});
				})
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		onClick(selectedRow) {
			this.SET_STATE({
				key: 'popupParams',
				value: {
					type: 'update',
					show: true,
					selectedRow: {
						...selectedRow,
						shopCd: this.shopCdConverter(selectedRow.shopCd),
						lineCd: this.lineCdConverter(selectedRow.lineCd)
					}
				}
			});
		},
		shopCdConverter(shopCd) {
			switch (shopCd) {
				case '*':
					return 'COMMON';
				case 'W':
					return 'BODY';
				case 'P':
					return 'PAINT';
				case 'A':
					return 'ASSEMBLY';
				case 'V':
					return 'PDI';
				case 'COMMON':
					return '*';
				case 'BODY':
					return 'W';
				case 'PAINT':
					return 'P';
				case 'ASSEMBLY':
					return 'A';
				case 'PDI':
					return 'V';
				default:
					return '';
			}
		},
		lineCdConverter(lineCd) {
			switch (lineCd) {
				case '1':
					return 'Line 1';
				case '2':
					return 'Line 2';
				case 'Line 1':
					return '1';
				case 'Line 2':
					return '2';
				default:
					return '';
			}
		}
	},
	created() {
		this.screen = this.screenArray.get(this.scrId);
	}
};
</script>

<style langType="scss">
.flag-status {
	color: red;
	font-weight: bold;
}
</style>
